module.exports = __webpack_public_path__ + "img/FI22387525.8d54167e.png";